const CIRCULAR_SIZE = 44;
const CACHE = {};
// linear regression [[40, 4],[100, 5]]
// coefficients based on figma design
const linReg = (size)=>size / 60 + 10 / 3;
// formula based on https://stackoverflow.com/questions/45719592/why-the-svg-size-and-the-circle-stroke-width-are-not-like-expected
const cachedThickness = (size)=>{
    const entry = CACHE[size];
    if (entry) {
        return entry;
    }
    const computed = linReg(size) / (size / CIRCULAR_SIZE);
    CACHE[size] = computed;
    return computed;
};
export default function Progress(theme) {
    return {
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.grey[300],
                    color: theme.palette.grey[700],
                    ...theme.applyStyles('dark', {
                        color: theme.palette.grey[200],
                        backgroundColor: theme.palette.grey[800]
                    }),
                    '&:before': {
                        backgroundColor: 'inherit'
                    }
                },
                bar2Indeterminate: {
                    opacity: 1
                },
                colorPrimary: {
                    backgroundColor: theme.palette.primary.shades['190p']
                },
                colorSecondary: {
                    backgroundColor: theme.palette.secondary.shades['190p']
                },
                colorInfo: {
                    backgroundColor: theme.palette.info.shades['190p']
                },
                colorSuccess: {
                    backgroundColor: theme.palette.success.shades['190p']
                },
                colorWarning: {
                    backgroundColor: theme.palette.warning.shades['190p']
                },
                colorError: {
                    backgroundColor: theme.palette.error.shades['190p']
                },
                colorUnderwriting: {
                    backgroundColor: theme.palette.underwriting.shades['190p']
                },
                buffer: {
                    backgroundColor: 'transparent'
                },
                dashed: {
                    backgroundImage: `radial-gradient(${theme.palette.grey[300]} 0%, ${theme.palette.grey[300]} 16%, transparent 42%)`,
                    ...theme.applyStyles('dark', {
                        backgroundImage: `radial-gradient(${theme.palette.grey[800]} 0%, ${theme.palette.grey[800]} 16%, transparent 42%)`
                    })
                },
                dashedColorPrimary: {
                    backgroundImage: `radial-gradient(${theme.palette.primary.shades['190p']} 0%, ${theme.palette.primary.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorSecondary: {
                    backgroundImage: `radial-gradient(${theme.palette.secondary.shades['190p']} 0%, ${theme.palette.secondary.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorInfo: {
                    backgroundImage: `radial-gradient(${theme.palette.info.shades['190p']} 0%, ${theme.palette.info.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorSuccess: {
                    backgroundImage: `radial-gradient(${theme.palette.success.shades['190p']} 0%, ${theme.palette.success.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorWarning: {
                    backgroundImage: `radial-gradient(${theme.palette.warning.shades['190p']} 0%, ${theme.palette.warning.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorError: {
                    backgroundImage: `radial-gradient(${theme.palette.error.shades['190p']} 0%, ${theme.palette.error.shades['190p']} 16%, transparent 42%)`
                },
                dashedColorUnderwriting: {
                    backgroundImage: `radial-gradient(${theme.palette.underwriting.shades['190p']} 0%, ${theme.palette.underwriting.shades['190p']} 16%, transparent 42%)`
                }
            }
        },
        MuiCircularProgress: {
            styleOverrides: {
                root: {
                    flexShrink: 0
                },
                circle: ({ ownerState })=>{
                    const size = ownerState.size || 40;
                    const thickness = cachedThickness(size);
                    return {
                        strokeWidth: thickness,
                        r: (CIRCULAR_SIZE - thickness) / 2
                    };
                }
            }
        }
    };
}
